import Api from "./Api";

class SearchApi extends Api {
  static search(query, params={}) {
    return this.get("search", {
      query: query,
      ...params
    });
  }

  static autocomplete(query, params={}) {
    return this.get("search/autocomplete", {
      query: query,
      ...params
    });
  }
}

export default SearchApi